<template>
  <div>
    <app-title>{{$route.name}}</app-title>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>